import { defineStore } from 'pinia'

export const useCheckoutStore = defineStore('checkoutStore', {
  state: () => ({
    shippingCost: null,
    shippingMethods: [],
  }),
  getters: {
    sortedShippingMethods(state) {
      return state.shippingMethods.sort((a, b) => a.sequence - b.sequence);
    },
  },
  actions: {
    setShippingCost(shippingCost) {
      this.shippingCost = shippingCost;
    },
    setShippingMethods(shippingMethods) {
      this.shippingMethods = shippingMethods;
    },

    // TODO: REMOVE
    // Fake data
    fillFakeShippingMethods() {
      if (this.shippingMethods.length <= 0) {
        this.shippingMethods = [...Array(10)].map((_, i) => ({
          id: `${i + 1}`,
          active: Math.random() < 0.5,
          name: `Shipping option ${i + 1}`,
          sequence: i + 1
        }));
      }
    },
    fillFakeShippingCosts() {
      this.shippingCost = {
        id: 1,
        priceFrom: 10,
        priceTo: 20,
        price: 15,
        shippingMethod: {
          name: "Standard Shipping",
          active: true,
          sequence: 1,
        },
      }
    },
  }
})
